export default {
  "title": "Avis de confidentialité du site web",
  "lastUpdated": "Dernière mise à jour : 26 mai 2026",
  "back": "← Retour à l'accueil",
  "intro": [
    {
      "type": "h3",
      "text": "À propos du présent avis de confidentialité"
    },
    {
      "type": "p",
      "text": "Votre vie privée est importante pour nous."
    },
    {
      "type": "p",
      "text": "Le présent avis de confidentialité du site web explique comment Demakstore Gıda İhracat San. ve Tic. Ltd. Şti., exploitant la marque DeMaxtore (« DeMaxtore », « nous », « notre »), collecte et traite les données personnelles lorsque vous utilisez www.demaxtore.com."
    },
    {
      "type": "p",
      "text": "Cela inclut toute donnée personnelle que vous pouvez fournir lorsque vous :"
    },
    {
      "type": "ul",
      "items": [
        "Visitez ou parcourez notre site web",
        "Créez ou utilisez un compte",
        "Soumettez une demande de sourcing",
        "Utilisez CommodityBid",
        "Utilisez FreightIQ",
        "Demandez des services d’inspection",
        "Demandez un support de suivi d’expédition en direct",
        "Nous contactez via des formulaires, e-mail, WhatsApp, téléphone, SMS ou autres canaux",
        "Présentez votre entreprise, vos produits ou vos services sur notre plateforme",
        "Communiquez avec DeMaxtore en tant qu’acheteur, fournisseur, fabricant, transitaire, partenaire d’inspection ou autre partenaire commercial"
      ]
    },
    {
      "type": "p",
      "text": "Le présent avis explique quelles données personnelles nous traitons, pourquoi nous les traitons, combien de temps nous les conservons, avec qui nous pouvons les partager et quels droits vous avez."
    }
  ],
  "sections": [
    {
      "title": "1. Qui est responsable de vos données personnelles ?",
      "blocks": [
        {
          "type": "p",
          "text": "Le responsable du traitement de vos données personnelles est :"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "Marque exploitée : DeMaxtore",
            "Site web : www.demaxtore.com",
            "E-mail : support@demaxtore.com",
            "E-mail alternatif : demaxtore@demaxtore.com"
          ]
        },
        {
          "type": "p",
          "text": "Aux fins du présent avis, DeMaxtore désigne la marque et la plateforme exploitées par Demakstore Gıda İhracat San. ve Tic. Ltd. Şti."
        }
      ]
    },
    {
      "title": "2. Quelles données personnelles collectons-nous ?",
      "blocks": [
        {
          "type": "p",
          "text": "Nous pouvons collecter et traiter les catégories de données personnelles suivantes :"
        },
        {
          "type": "h3",
          "text": "Informations d’identification"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Nom complet",
            "Nom du représentant de l’entreprise",
            "Photo de profil, le cas échéant",
            "Informations d’identification ou de vérification, si la loi l’exige"
          ]
        },
        {
          "type": "h3",
          "text": "Coordonnées professionnelles"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "E-mail professionnel",
            "Numéro de téléphone",
            "Intitulé de poste",
            "Service",
            "Nom de l’entreprise",
            "Site web de l’entreprise",
            "Pays et ville",
            "Adresse professionnelle, le cas échéant"
          ]
        },
        {
          "type": "h3",
          "text": "Informations sur l’entreprise et le fournisseur"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Profil d’entreprise",
            "Catégories de produits",
            "Spécifications produit",
            "Capacités de fabrication",
            "Certifications",
            "Détails de vérification fournisseur",
            "Rôle acheteur ou fournisseur"
          ]
        },
        {
          "type": "h3",
          "text": "Informations de sourcing et d’appels d’offres"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Demandes de sourcing produit",
            "Demandes CommodityBid",
            "Quantité, conditionnement, prix cible et exigences de livraison",
            "Offres fournisseurs",
            "Communications acheteur/fournisseur",
            "Détails de comparaison d’offres"
          ]
        },
        {
          "type": "h3",
          "text": "Informations logistiques et d’expédition"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Détails de demande de fret",
            "Informations d’enlèvement et de livraison",
            "Type de cargaison et détails d’expédition",
            "Données de comparaison FreightIQ",
            "Offres de transitaires",
            "Mises à jour de suivi",
            "Informations logistiques porte à porte"
          ]
        },
        {
          "type": "h3",
          "text": "Informations d’inspection"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Détails de demande d’inspection",
            "Localisation usine ou fournisseur",
            "Exigences qualité produit",
            "Rapports d’inspection",
            "Photos, documents et communications associées"
          ]
        },
        {
          "type": "h3",
          "text": "Informations financières et transactionnelles"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Informations de facturation",
            "Dossiers commerciaux liés aux paiements",
            "Coordonnées bancaires, si nécessaires",
            "Informations comptables et fiscales"
          ]
        },
        {
          "type": "h3",
          "text": "Informations de conformité"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "KYC / connaissance fournisseur",
            "Contrôles anti-fraude",
            "Conformité commerciale",
            "Lutte contre le blanchiment",
            "Anti-corruption",
            "Filtrage sanctions / parties restreintes"
          ]
        },
        {
          "type": "h3",
          "text": "Données techniques et d’usage"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Adresse IP",
            "Type et version du navigateur",
            "Type d’appareil",
            "Système d’exploitation",
            "Fuseau horaire et paramètres de localisation",
            "Données d’usage du site",
            "Pages consultées",
            "Données de connexion",
            "Préférences cookies et consentement",
            "Interaction avec les fonctionnalités"
          ]
        },
        {
          "type": "h3",
          "text": "Données marketing et de communication"
        },
        {
          "type": "p",
          "text": "Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Préférences marketing",
            "Préférences de communication",
            "Enregistrements e-mail, WhatsApp, SMS, téléphone ou formulaires",
            "Données d’interaction campagne"
          ]
        },
        {
          "type": "p",
          "text": "Si certaines informations sont obligatoires pour un service, nous pourrions ne pas pouvoir fournir ce service si les informations requises ne sont pas fournies."
        }
      ]
    },
    {
      "title": "3. Pourquoi utilisons-nous vos données personnelles ?",
      "blocks": [
        {
          "type": "p",
          "text": "Nous traitons les données personnelles aux fins suivantes :"
        },
        {
          "type": "ul",
          "items": [
            "Fournir l’accès au site et aux services DeMaxtore",
            "Créer et gérer les comptes acheteurs, fournisseurs et partenaires",
            "Traiter les demandes de sourcing, RFQ et CommodityBid",
            "Comparer les offres de fret et prendre en charge FreightIQ",
            "Coordonner l’inspection et le suivi d’expédition en direct",
            "Communiquer avec utilisateurs, acheteurs, fournisseurs et partenaires logistiques",
            "Vérifier les informations entreprise, fournisseur et partenaire",
            "Fournir le support client et gérer les relations commerciales",
            "Améliorer le site, les services, la recherche et l’expérience utilisateur",
            "Personnaliser les recommandations pertinentes lorsque la loi l’autorise",
            "Envoyer des communications de service, transactionnelles, légales et marketing autorisées",
            "Prévenir la fraude, les abus, le spam et l’activité non autorisée",
            "Respecter les obligations légales, fiscales, comptables, réglementaires et de conformité",
            "Protéger les droits, la sécurité, la réputation et les intérêts légitimes de DeMaxtore"
          ]
        }
      ]
    },
    {
      "title": "4. Services personnalisés et profilage",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore peut utiliser certaines données pour améliorer la pertinence des résultats de recherche, des recommandations fournisseurs, des comparaisons de fret ou des suggestions de sourcing."
        },
        {
          "type": "p",
          "text": "Par exemple, nous pouvons analyser :"
        },
        {
          "type": "ul",
          "items": [
            "Requêtes de recherche",
            "Intérêts produits",
            "Historique de sourcing",
            "Catégories demandées",
            "Préférences pays ou marché",
            "Comportement acheteur ou fournisseur",
            "Modèles d’usage de la plateforme"
          ]
        },
        {
          "type": "p",
          "text": "Cela peut nous aider à proposer des suggestions plus pertinentes de fournisseurs, catégories, options de fret ou services."
        },
        {
          "type": "p",
          "text": "Lorsque ce traitement nécessite un consentement, nous le demanderons avant d’utiliser ces données."
        },
        {
          "type": "p",
          "text": "Nous n’utilisons pas de décision automatisée produisant des effets juridiques ou similaires significatifs sans intervention humaine."
        }
      ]
    },
    {
      "title": "5. Communications marketing",
      "blocks": [
        {
          "type": "p",
          "text": "Nous pouvons envoyer des communications marketing sur les services DeMaxtore, notamment sourcing, CommodityBid, FreightIQ, inspection, suivi d’expédition et autres solutions B2B d’import."
        },
        {
          "type": "p",
          "text": "Ces communications peuvent être envoyées par :"
        },
        {
          "type": "ul",
          "items": [
            "E-mail",
            "WhatsApp",
            "SMS",
            "Téléphone",
            "Autres canaux électroniques"
          ]
        },
        {
          "type": "p",
          "text": "Vous pouvez vous désabonner à tout moment via l’option de désinscription ou en nous contactant à :"
        },
        {
          "type": "p",
          "text": "support@demaxtore.com"
        },
        {
          "type": "p",
          "text": "Même après désinscription, nous pouvons envoyer des messages importants liés au service, à la sécurité, au juridique ou aux transactions."
        }
      ]
    },
    {
      "title": "6. Liens tiers",
      "blocks": [
        {
          "type": "p",
          "text": "Notre site peut inclure des liens vers des sites, outils, plug-ins, applications, fournisseurs, fabricants, prestataires logistiques, partenaires d’inspection ou plateformes externes."
        },
        {
          "type": "p",
          "text": "Cliquer sur des liens tiers ou activer des intégrations peut permettre à ces tiers de collecter ou traiter des données vous concernant."
        },
        {
          "type": "p",
          "text": "DeMaxtore ne contrôle pas les sites tiers et n’est pas responsable de leurs pratiques de confidentialité. Consultez leurs avis de confidentialité et politiques de cookies."
        }
      ]
    },
    {
      "title": "7. Cookies et gestion du consentement",
      "blocks": [
        {
          "type": "p",
          "text": "Nous utilisons des cookies et technologies similaires sur www.demaxtore.com pour :"
        },
        {
          "type": "ul",
          "items": [
            "Assurer le fonctionnement du site",
            "Mémoriser vos préférences cookies",
            "Améliorer les performances",
            "Analyser le trafic",
            "Améliorer l’expérience utilisateur",
            "Soutenir le marketing et la publicité"
          ]
        },
        {
          "type": "p",
          "text": "Lorsque la loi l’exige, nous demandons votre consentement avant de placer des cookies non essentiels."
        },
        {
          "type": "p",
          "text": "Vous pouvez accepter, refuser ou gérer vos préférences via notre bannière ou outil de préférences cookies."
        },
        {
          "type": "p",
          "text": "Pour plus de détails, consultez notre politique des cookies distincte."
        }
      ]
    },
    {
      "title": "8. Avec qui partageons-nous vos données personnelles ?",
      "blocks": [
        {
          "type": "p",
          "text": "Nous pouvons partager vos données personnelles avec :"
        },
        {
          "type": "ul",
          "items": [
            "Acheteurs",
            "Fournisseurs",
            "Fabricants",
            "Transitaires",
            "Prestataires logistiques",
            "Prestataires d’inspection",
            "Partenaires douane, documentation ou commerce",
            "Prestataires IT, hébergement, CRM, analytique, e-mail et cloud",
            "Prestataires marketing et communication",
            "Conseils juridiques, comptables, audit et conformité",
            "Banques ou prestataires de paiement, si nécessaire",
            "Autorités publiques, tribunaux, régulateurs ou forces de l’ordre si la loi l’exige"
          ]
        },
        {
          "type": "p",
          "text": "Nous ne partageons les données que lorsque cela est nécessaire aux fins décrites dans le présent avis ou lorsque la loi l’exige."
        },
        {
          "type": "p",
          "text": "Nous ne vendons pas de données personnelles."
        }
      ]
    },
    {
      "title": "9. Transferts internationaux de données",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore opère dans le commerce international ; vos données peuvent être transférées ou consultées hors de votre pays de résidence."
        },
        {
          "type": "p",
          "text": "Lorsque la loi l’exige, nous utilisons des garanties appropriées, notamment contractuelles, techniques, organisationnelles ou autres mécanismes licites."
        }
      ]
    },
    {
      "title": "10. Combien de temps conservons-nous vos données ?",
      "blocks": [
        {
          "type": "p",
          "text": "Nous conservons les données personnelles uniquement le temps nécessaire aux fins décrites dans le présent avis."
        },
        {
          "type": "p",
          "text": "La durée peut dépendre de :"
        },
        {
          "type": "ul",
          "items": [
            "Le type de données",
            "La finalité du traitement",
            "La durée de la relation commerciale",
            "Les obligations légales, fiscales, comptables ou réglementaires",
            "Les besoins de résolution de litiges",
            "La prévention de la fraude et la sécurité"
          ]
        },
        {
          "type": "p",
          "text": "Lorsqu’elles ne sont plus nécessaires, nous les supprimons, anonymisons ou archivons de manière sécurisée."
        }
      ]
    },
    {
      "title": "11. Comment protégeons-nous vos données ?",
      "blocks": [
        {
          "type": "p",
          "text": "Nous appliquons des mesures techniques et organisationnelles raisonnables pour protéger les données contre :"
        },
        {
          "type": "ul",
          "items": [
            "Accès non autorisé",
            "Perte",
            "Usage abusif",
            "Altération",
            "Divulgation",
            "Destruction",
            "Activité frauduleuse",
            "Incidents de sécurité"
          ]
        },
        {
          "type": "p",
          "text": "Aucun service en ligne ne peut être garanti totalement sécurisé. Les utilisateurs doivent garder leurs identifiants confidentiels et nous avertir en cas d’accès suspect."
        }
      ]
    },
    {
      "title": "12. Vos droits",
      "blocks": [
        {
          "type": "p",
          "text": "Selon les lois applicables, vous pouvez avoir le droit de :"
        },
        {
          "type": "ul",
          "items": [
            "Accéder à vos données",
            "Demander la rectification",
            "Demander l’effacement",
            "Vous opposer à certains traitements",
            "Demander la limitation",
            "Retirer votre consentement",
            "Demander la portabilité",
            "Introduire une réclamation auprès d’une autorité compétente"
          ]
        },
        {
          "type": "p",
          "text": "Pour exercer vos droits, contactez-nous à :"
        },
        {
          "type": "p",
          "text": "support@demaxtore.com"
        },
        {
          "type": "p",
          "text": "Nous pouvons devoir vérifier votre identité avant de répondre."
        }
      ]
    },
    {
      "title": "13. WhatsApp et autres canaux de communication",
      "blocks": [
        {
          "type": "p",
          "text": "Si vous nous contactez via WhatsApp, e-mail, SMS, téléphone ou autres canaux, nous pouvons traiter et conserver le contenu et les coordonnées associées."
        },
        {
          "type": "p",
          "text": "Cela nous aide à :"
        },
        {
          "type": "ul",
          "items": [
            "Répondre à votre demande",
            "Fournir le support",
            "Gérer les relations acheteur/fournisseur/partenaire",
            "Coordonner sourcing, fret, inspection ou expédition",
            "Tenir des dossiers commerciaux"
          ]
        },
        {
          "type": "p",
          "text": "Les outils tiers peuvent également traiter vos données selon leurs propres politiques."
        }
      ]
    },
    {
      "title": "14. Opérations commerciales",
      "blocks": [
        {
          "type": "p",
          "text": "En cas de fusion, acquisition, investissement, restructuration, cession d’actifs ou opération similaire, des données personnelles peuvent être transférées ou divulguées lorsque la loi le permet."
        },
        {
          "type": "p",
          "text": "Dans ce cas, nous prendrons des mesures appropriées pour protéger les données."
        }
      ]
    },
    {
      "title": "15. Données des mineurs",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore fournit des services B2B et ne vise pas les enfants."
        },
        {
          "type": "p",
          "text": "Nous ne collectons pas sciemment de données de personnes de moins de 18 ans. Si nous en avons connaissance, nous les supprimerons dans des délais raisonnables."
        }
      ]
    },
    {
      "title": "16. Mises à jour du présent avis",
      "blocks": [
        {
          "type": "p",
          "text": "Nous pouvons mettre à jour cet avis de confidentialité du site web pour refléter des changements de services, d’exigences légales, d’opérations ou de pratiques de traitement."
        },
        {
          "type": "p",
          "text": "La dernière version sera publiée sur www.demaxtore.com avec la date mise à jour."
        }
      ]
    },
    {
      "title": "17. Nous contacter",
      "blocks": [
        {
          "type": "p",
          "text": "Pour toute question, demande ou préoccupation concernant le présent avis ou le traitement de vos données, contactez-nous :"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "Marque exploitée : DeMaxtore",
            "Site web : www.demaxtore.com",
            "E-mail : support@demaxtore.com",
            "E-mail alternatif : demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
